import { useEffect } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
var getListenerTarget = function getListenerTarget(target) {
  return target && 'current' in target ? target.current : target;
};
export var useListener = function useListener(type, listener, options) {
  var _ref = options !== null && options !== void 0 ? options : {},
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? window : _ref$target;
  var listenerRef = useMutableRef(listener);
  useEffect(function () {
    var handler = function handler(ev) {
      return listenerRef.current(ev);
    };
    var targetElement = getListenerTarget(target);
    if (targetElement && active) {
      targetElement === null || targetElement === void 0 || targetElement.addEventListener(type, handler);
    }
    return function () {
      targetElement === null || targetElement === void 0 || targetElement.removeEventListener(type, handler);
    };
  }, [type, active, target]);
};